module.exports = __webpack_public_path__ + "media/images/icons/menu-f2944ee54413d450fdaec5ebdf0e22da.svg";